/** Parse une réponse fetch en JSON sans planter sur une page HTML (erreur 520/524 Cloudflare, proxy…). */
export async function safeJson(r) {
    const text = await r.text().catch(() => "");
    try {
        return text ? JSON.parse(text) : {};
    } catch {
        const status = r.status >= 500 ? "Le serveur est temporairement indisponible (erreur " + r.status + "). Réessayez dans quelques secondes." : `Réponse invalide du serveur (${r.status}).`;
        return { detail: status, __html: true };
    }
}

export function errorFrom(r, j) {
    return new Error(typeof j?.detail === "string" ? j.detail : Array.isArray(j?.detail) ? j.detail.map((d) => d.msg || JSON.stringify(d)).join(", ") : `Erreur ${r.status}`);
}
